import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../../utilities/classNames";
import TextCardBase from "../../bases/TextCardBase/TextCardBase";
import { Rank } from "../../../../../core/types";

var TextCard = function TextCard(_ref) {
  var borderless = _ref.borderless,
      description = _ref.description,
      eyebrow = _ref.eyebrow,
      footer = _ref.footer,
      heading = _ref.heading,
      headingRank = _ref.headingRank,
      href = _ref.href,
      size = _ref.size,
      id = _ref.id;
  var getClassName = getClassNameFactory(TextCard.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(TextCardBase, {
    borderless: borderless,
    description: description,
    eyebrow: eyebrow,
    footer: footer,
    heading: heading,
    headingRank: headingRank,
    href: href,
    size: size,
    id: id
  }));
};

TextCard.displayName = "TextCard";
TextCard.sizes = TextCardBase.sizes;
/* eslint-disable max-len */

TextCard.propTypes = {
  /**
   * Hide the border
   */
  borderless: PropTypes.bool,

  /**
   * Description text
   */
  description: PropTypes.node,

  /**
   * Eyebrow text
   */
  eyebrow: PropTypes.string,

  /**
   * Footer. Should be a valid card footer, like ArticleCardFooter.
   */
  footer: PropTypes.node.isRequired,

  /**
   * Heading text
   */
  heading: PropTypes.string.isRequired,

  /**
   * Heading rank. 1 will render `<h1 />`, and so on. Defaults to 3.
   */
  headingRank: PropTypes.oneOf(Object.values(Rank)),

  /**
   * Card URL
   */
  href: PropTypes.string.isRequired,

  /**
   * Size of the Card. Will set the minumum height and grow to fit content.
   */
  size: PropTypes.oneOf(TextCard.sizes).isRequired,

  /**
   * id to identity component for Selenium Test
   */
  id: PropTypes.string
};
/* eslint-enable max-len */

TextCard.defaultProps = {
  headingRank: Rank.Third
};
export default TextCard;